import React, { memo } from 'react'

import { constants } from '../../../constants'
import { util } from '../../../util'

const WeeklyCircleField = ({
    // list,
    weekList,
    handleClick,
    // name,
    className,
    isDisabled = false,
    // ...rest
}) => {
    //Constants
    const { getDays } = constants
    const days = getDays()

    const onDaySelected = day => {
        if (isDisabled) return null
        if (weekList.findIndex(el => el === day) >= 0) {
            const filterList = weekList.filter(el => el !== day)
            filterList.length > 0 && handleClick(filterList)
        } else {
            handleClick([...weekList, day])
        }
    }
    return (
        <div className={'repeat-setting__weekly'}>
            <div className={util.joinClasses('days', className)}>
                {Object.keys(days).map(key => {
                    return (
                        <span
                            className={`dot ${weekList.includes(key) && 'selected'} ${
                                isDisabled && '__disabled'
                            }`}
                            key={key}
                            onClick={() => onDaySelected(key)}
                        >
                            {days[key][0]}
                        </span>
                    )
                })}
            </div>
        </div>
    )
}

export default memo(WeeklyCircleField)
